<rt-wysiwyg-inline-button
  rt-overlay-origin
  #trigger="rtOverlayOrigin"
  [clipboardValue]="state.active.id"
  [displayValue]="state.activeIdWithoutBrackets"
  [rtTooltip]="state.tooltipMessage"
  [active]="placeholdersDropdown.open"
  [status]="state.active.data.status!"
  (click)="placeholdersDropdown.open = true"
></rt-wysiwyg-inline-button>

<ng-template
  rt-connected-overlay
  #placeholdersDropdown="rtConnectedOverlay"
  [origin]="trigger"
  (backdropClick)="placeholdersDropdown.open = false"
  hasBackdrop
>
  <rt-wysiwyg-placeholder-dropdown
    [placeholders]="state.placeholders"
    [active]="state.active"
    (action)="emit($event)"
  ></rt-wysiwyg-placeholder-dropdown>
</ng-template>
